import { HttpClient, ListParams } from './http-client';
import { Observable } from 'rxjs';
import Paginate from '../interfaces/paginate';

export class SummaryTaskService extends HttpClient {
  index(
    farmId: string,
    type: 'control' | 'calving' | 'breeding',
    params?: ListParams
  ): Observable<Paginate<any>> {
    return this.get<Paginate<any>>(
      `/api/farms/${farmId}/livestock/summary/dairy/temp/${type}`,
      params
    );
  }

  store(farmId: string, file: FormData): Observable<FormData> {
    return this.post<FormData>(
      `/api/farms/${farmId}/livestock/summary/dairy/store`,
      file,
      {
        headers: { 'Content-Type': null },
      }
    );
  }
}
